export default __webpack_public_path__ + "c68692b42a21e20eef9e3235ae271971.png";